"use client";

/**
 * BottomNav — 모바일 하단 footer 네비게이션 (사용자 결정 2026-05-21).
 *
 * AppSidebar 가 모바일 (≤720px) 에서 hide 되는 대신 이 footer 가 표시됨.
 * NAV_ITEMS + COMMUNITY_NAV 중 enabled 만 (Coming Soon 항목은 모바일 footer 에서 숨김 — 공간 제약).
 *
 * - fixed bottom-0 left-0 right-0, h-[56px]
 * - safe-area-inset-bottom 지원 (iPhone notch)
 * - main 에 padding-bottom 추가 (AppShell 에서 처리)
 */
import Link from "next/link";
import { usePathname } from "next/navigation";
import { NAV_ITEMS, COMMUNITY_NAV } from "./app-sidebar";

export function BottomNav() {
  const pathname = usePathname();
  // enabled 만 표시 (Coming Soon 모바일 footer 제외)
  const items = [...NAV_ITEMS, COMMUNITY_NAV].filter((it) => it.enabled);

  return (
    <nav
      aria-label="모바일 하단 네비게이션"
      // 사용자 결정 2026-05-21: border-t 제거 + 위쪽 그림자. AppShell 이 isMobile 일 때만 mount 함.
      className="fixed bottom-0 left-0 right-0 z-30 flex items-stretch bg-[var(--bs-paper)]"
      style={{
        paddingBottom: "env(safe-area-inset-bottom)",
        boxShadow: "0 -4px 16px -2px rgba(0, 0, 0, 0.08), 0 -1px 4px rgba(0, 0, 0, 0.04)",
      }}
    >
      {items.map((item) => {
        const Icon = item.icon;
        // /analyze/[ticker] 같은 sub-path 도 매칭하려고 startsWith.
        // 단 "/" 는 정확히 일치할 때만 active (모든 path 가 / 로 시작).
        const baseHref = item.href.split("#")[0] || "/";
        const isActive =
          baseHref === "/"
            ? pathname === "/"
            : pathname === baseHref || pathname.startsWith(`${baseHref}/`);

        return (
          <Link
            key={item.label}
            href={item.href}
            className={`flex-1 flex flex-col items-center justify-center gap-1 py-2 text-[10px] font-semibold transition-colors no-underline ${
              isActive
                ? "text-[var(--bs-red-500)]"
                : "text-[var(--bs-gray-500)] hover:text-[var(--bs-ink)]"
            }`}
            aria-current={isActive ? "page" : undefined}
          >
            <Icon className="w-5 h-5" />
            <span className="truncate max-w-full px-1">{item.label}</span>
          </Link>
        );
      })}
    </nav>
  );
}
